<h2 mat-dialog-title>
  <div class="dialog-title-grid manage-subscription-title-grid">
    <div class="left-col dialog-title-left">
      Manage Account
    </div>
    <div class="right-col dialog-title-right">
      <button mat-icon-button aria-label="Close" (click)="close()" class="dialog-title-close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</h2>
<div mat-dialog-content>
  @if(errorMessage()){
    <div class="error-message">
      {{ errorMessage() }}
    </div>
  }
  <div class="team-pricing-table">
    <!-- My Plan Row -->
    @if(subscriptionInfo()) {
      <div class="team-pricing-row team-pricing-header">
        <div class="team-pricing-label">My plan</div>
        <div class="team-pricing-value">{{ subscriptionInfo().basePrice | currency:'USD':'symbol':'1.2-2'  }}/month</div>
      </div>
    }
    <div class="team-pricing-row team-header-row">
      <div class="team-pricing-label team-header">Team</div>
    </div>
    <!-- Team Members Rows -->
    @for (member of teamMembers(); track member.email) {
      <div class="team-pricing-row">
        <div class="team-pricing-label">
          <div class="member-info">
            <app-user-avatar
              [avatar]="member.avatar"
              [size]="'tiny'"
              [fullName]="member.name || member.email"
            ></app-user-avatar> {{ member.email }}
          </div>
        </div>
        <div class="team-pricing-value">{{ subscriptionInfo().userPrice | currency:'USD':'symbol':'1.2-2'  }}/month</div>
      </div>
    }
    <!-- Total Row -->
    @if(subscriptionInfo()) {
      <div class="team-pricing-row total-row">
        <div class="team-pricing-label">Total monthly fees</div>
        <div class="team-pricing-value">{{ subscriptionInfo().totalPrice | currency: 'USD': 'symbol':'1.2-2' }}/month</div>
      </div>
    }
    @if(customerSessionClientSecret() && setupIntentClientSecret()){
      <div class="stripe-form-container">
        <div class="stripe-header">
          <h3>Payment Method</h3>
        </div>
        @if (stripeElementsOptions()) {
          <ngx-stripe-elements
            [stripe]="stripe"
            [elementsOptions]="stripeElementsOptions()"
            (elements)="onElementsCreated($event)"
          >
            <ngx-stripe-payment [options]="paymentElementOptions()" (change)="onPaymentElementChange($event)"></ngx-stripe-payment>
          </ngx-stripe-elements>
        }
        @if (paymentFormChanged()) {
          <div class="stripe-form-actions">
            <app-weave-button
              [text]="savingPaymentMethod() ? 'Saving...' : 'Save Payment Method'"
              [classes]="'button primary'"
              [disabled]="savingPaymentMethod()"
              (clicked)="savePaymentMethod()"
            ></app-weave-button>
          </div>
        }
      </div>
    }
  </div>
</div>
<div mat-dialog-actions align="start">
  @if(subscriptionInfo()){
    @if(accountStatus.isAutoRenew){
    <app-weave-button
      [text]="'Cancel Account'"
      [classes]="'button secondary'"
      (click)="cancelSubscription()"
      ></app-weave-button>
    } @else {
      <strong>Your account will be closed as of {{ accountStatus.subscription.nextBillingDate | date:'longDate' }}.</strong>
    }
  }
</div>
